import { render, staticRenderFns } from "./admin_user_detail.vue?vue&type=template&id=3892bb4a&scoped=true&"
import script from "./admin_user_detail.vue?vue&type=script&lang=ts&"
export * from "./admin_user_detail.vue?vue&type=script&lang=ts&"
import style0 from "./admin_user_detail.vue?vue&type=style&index=0&id=3892bb4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892bb4a",
  null
  
)

export default component.exports